import React, { Component } from 'react';
import { connect } from 'react-redux';

class ProgressBar extends Component {

  constructor(props){
    super(props);
  }

  render() {
    const { tours, user } = this.props;


    return (
        <div className={"pg-bar "}>
            <div className={"pg-bar__line " + ((tours.count || (user && user.count))?"pg-bar__line_progress":"pg-bar__line_complete")}></div>
        </div>
    );
  }
}



function mapStateToProps (state) {
  return {
    tours: state.tours.loader,
    user: state.user.loader
  }
}


export default connect(mapStateToProps)(ProgressBar)




// WEBPACK FOOTER //
// ./src/common/components/wiget/ProgressBar.js